import { formatDateWithInitial } from "@/shared/libs/date";
import {
  createUrlWithSearchParams,
  createSearchParams,
} from "@/shared/libs/url-utils";
import type { ReadonlyURLSearchParams } from "next/navigation";
import { format } from "date-fns-jalali";

export function createCalendarDate(
  date: string,
  pathName: string,
  searchParams: ReadonlyURLSearchParams,
) {
  return createUrlWithSearchParams(
    pathName,
    createSearchParams(new URLSearchParams(searchParams), [
      {
        name: "depart",
        value: date,
      },
    ]),
  );
}

export function formatPriceCalendarDate(device: DeviceType, date: string) {
  return device === "mobile"
    ? formatDateWithInitial(date)
    : format(date, "EEEE - d MMMM");
}
